/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForExecutiveDashboardReport extends models.ScheduleExecutionParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForExecutiveDashboardReport");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForExecutiveDashboardReport.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForExecutiveDashboardReport>): ScheduleExecutionParameterForExecutiveDashboardReport {
        let obj = Object.assign(new ScheduleExecutionParameterForExecutiveDashboardReport(), model);
        ScheduleExecutionParameterForExecutiveDashboardReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForExecutiveDashboardReport>): ScheduleExecutionParameterForExecutiveDashboardReport {
        if (!model) return null;
        return ScheduleExecutionParameterForExecutiveDashboardReport.newInstance(<ScheduleExecutionParameterForExecutiveDashboardReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForExecutiveDashboardReport) {
        if (!obj) return;

        models.ScheduleExecutionParameterForExecutiveDashboardReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForExecutiveDashboardReport): boolean {
        if (models.ScheduleExecutionParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForExecutiveDashboardReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.dashboard) {
            models.DashboardConfiguration.fixupPrototype(this.dashboard);
        }
    }

    dashboard: models.DashboardConfiguration;

    /**
     * Executive Dashboard Report subscription type
     */
    subscription_type: models.ExecutiveDashboardReportSubscriptionType;

    /**
     * Specifies the format of the file being exported.
     */
    export_format: models.ExportFormat;

}
